import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_28520759 from 'nuxt_plugin_plugin_28520759' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4a7fde9a from 'nuxt_plugin_sentryserver_4a7fde9a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_75069f2b from 'nuxt_plugin_sentryclient_75069f2b' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_templatesplugin47c53706_68277080 from 'nuxt_plugin_templatesplugin47c53706_68277080' // Source: ./templates.plugin.47c53706.js (mode: 'client')
import nuxt_plugin_prismic_03d2eaed from 'nuxt_plugin_prismic_03d2eaed' // Source: ./prismic/plugins/prismic.js (mode: 'all')
import nuxt_plugin_prismiccomponents_db36fd44 from 'nuxt_plugin_prismiccomponents_db36fd44' // Source: ./prismic/plugins/prismic-components.js (mode: 'all')
import nuxt_plugin_workbox_d8a4356a from 'nuxt_plugin_workbox_d8a4356a' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_01429d44 from 'nuxt_plugin_metaplugin_01429d44' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_040656d2 from 'nuxt_plugin_iconplugin_040656d2' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_4d89afef from 'nuxt_plugin_axios_4d89afef' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_analytics_2e48c327 from 'nuxt_plugin_analytics_2e48c327' // Source: ../../../plugins/analytics.js (mode: 'all')
import nuxt_plugin_mixpanelclient_8a9ad208 from 'nuxt_plugin_mixpanelclient_8a9ad208' // Source: ../../../plugins/mixpanel.client.js (mode: 'client')
import nuxt_plugin_vuecookies_026d4812 from 'nuxt_plugin_vuecookies_026d4812' // Source: ../../../plugins/vue-cookies (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Welcome to Nurole - the best board-level recruitment","meta":[{"hid":"charset","charset":"utf-8"},{"hid":"robots","name":"robots","content":"index, follow"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"The hiring platform for building high-impact boards. Reduce the risk of missing out on the non-executive talent your board needs. Create a powerful, diverse shortlist of exceptional candidates, invisible to traditional headhunting."},{"hid":"og:description","name":"og:description","content":"The hiring platform for building high-impact boards. Reduce the risk of missing out on the non-executive talent your board needs. Create a powerful, diverse shortlist of exceptional candidates, invisible to traditional headhunting."},{"name":"format-detection","content":"telephone=no"},{"name":"og:title","content":"Welcome to Nurole - the best board-level recruitment"},{"name":"og:site_name","content":"Welcome to Nurole - the best board-level recruitment"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons"}],"script":[{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-MHTKE8TVCE","async":true},{"hid":"ga4","body":true,"innerHTML":"\n        window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n\n        gtag('config', 'G-MHTKE8TVCE', { debug_mode: false });\n        ","type":"text\u002Fjavascript"},{"id":"ze-snippet","src":"https:\u002F\u002Fstatic.zdassets.com\u002Fekr\u002Fsnippet.js?key=3afd7a80-35f4-4331-8390-1eac9fa7bf72","defer":true,"async":true},{"hid":"linkedin-vars","body":true,"innerHTML":"\n          _linkedin_partner_id = '44889';\n          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];\n          window._linkedin_data_partner_ids.push(_linkedin_partner_id);\n        ","type":"text\u002Fjavascript"},{"hid":"linkedin-src","body":true,"innerHTML":"\n          (function(l) {\n            if (!l){window.lintrk = function(a,b){\n              window.lintrk.q.push([a,b])};\n              window.lintrk.q=[]\n            }\n            var s = document.getElementsByTagName('script')[0];\n            var b = document.createElement('script');\n            b.type = 'text\u002Fjavascript';\n            b.async = true;\n            b.src = 'https:\u002F\u002Fsnap.licdn.com\u002Fli.lms-analytics\u002Finsight.min.js';\n            s.parentNode.insertBefore(b, s);\n          })(window.lintrk);\n        ","type":"text\u002Fjavascript"}],"noscript":[{"hid":"linkedin-noscript","body":true,"innerHTML":"\n          \u003Cimg height='1' width='1' style='display:none;' alt='' src='https:\u002F\u002Fpx.ads.linkedin.com\u002Fcollect\u002F?pid=44889&fmt=gif' \u002F\u003E\n        "}],"__dangerouslyDisableSanitizersByTagID":{"linkedin-vars":["innerHTML"],"linkedin-src":["innerHTML"],"linkedin-noscript":["innerHTML"],"ga4":["innerHTML"]},"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_28520759 === 'function') {
    await nuxt_plugin_plugin_28520759(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4a7fde9a === 'function') {
    await nuxt_plugin_sentryserver_4a7fde9a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_75069f2b === 'function') {
    await nuxt_plugin_sentryclient_75069f2b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin47c53706_68277080 === 'function') {
    await nuxt_plugin_templatesplugin47c53706_68277080(app.context, inject)
  }

  if (typeof nuxt_plugin_prismic_03d2eaed === 'function') {
    await nuxt_plugin_prismic_03d2eaed(app.context, inject)
  }

  if (typeof nuxt_plugin_prismiccomponents_db36fd44 === 'function') {
    await nuxt_plugin_prismiccomponents_db36fd44(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_d8a4356a === 'function') {
    await nuxt_plugin_workbox_d8a4356a(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_01429d44 === 'function') {
    await nuxt_plugin_metaplugin_01429d44(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_040656d2 === 'function') {
    await nuxt_plugin_iconplugin_040656d2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4d89afef === 'function') {
    await nuxt_plugin_axios_4d89afef(app.context, inject)
  }

  if (typeof nuxt_plugin_analytics_2e48c327 === 'function') {
    await nuxt_plugin_analytics_2e48c327(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mixpanelclient_8a9ad208 === 'function') {
    await nuxt_plugin_mixpanelclient_8a9ad208(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecookies_026d4812 === 'function') {
    await nuxt_plugin_vuecookies_026d4812(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
